<template>
  <div class="car-content-introduction">
    <span class="car-headline" v-if="validOffer">
      {{$t('offer.title')}}
    </span>
    <span class="car-headline" v-else>
      {{$t('offer.emptyOfferTitle')}}
    </span>
    <p v-if="validOffer">
      {{$t('offer.description')}}
    </p>
    <p v-else>
      {{$t('offer.emptyOfferDescription')}}
    </p>
  </div>
</template>

<script>
export default {
  name: 'OfferHeader',
  props: {
    validOffer: {
      type: Boolean,
      required: true
    }
  }
}
</script>
